import React, { useState } from 'react';
import { Modal } from 'antd-mobile'
//@ts-ignore
import QRCode from 'qrcode-react';
import moment from 'moment'
import "./index.css";
import icon from '../../../assets/card-top.png'

const MineModal = (props: any) => {
  const { visible, onClose, data } = props;
  const [showCode, setShowCode] = useState(true);
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      transparent={true}
      style={{ width: '90%', overflow: 'visible', position: 'absolute', top: 112 }}
      bodyStyle={{ overflow: 'visible' }}

    >
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', paddingTop: 65 }}>
        <div style={{ backgroundImage: `url(${icon})` }} className='mine-modal-icon' />
        <div className='mine-modal-button' onClick={() => setShowCode(prevToken => !prevToken)}>
          {showCode === true ? '电子章签到' : '我的二维码'}
        </div>
        {showCode === true ? (
          <div>
            <div className='mine-modal-name'>
              <span style={{ zIndex: 99, position: 'relative' }}>{data.username}</span>
              <div className='mine-modal-name-z' />
            </div>
            <div style={{ width: 158, height: 158, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', border: '1px solid #e3e3e3' }}>
              <QRCode value={data.erweima} size={136} />
            </div>
            <div className='mine-modal-code'>{`识别码：${data.str}`}</div>

            <div className='mine-modal-tip'>向主办方出示该二维码用于会中服务</div>
          </div>
        ) : (
            <div className='mine-box'>请在虚线范围内进行签章</div>
          )}
      </div>
    </Modal>
  )
}

export default MineModal;